module.exports = __webpack_public_path__ + "img/riz.64cd0811.png";